'use client';

import { FC, useMemo } from 'react';

import { ElementProps } from '@ravago/shared/page-data/models/base';
import { NormalizedCaseStudy } from '@ravago/shared/page-data/models/contentful-mapped';
import { CaseStudyFeaturesListNode } from '@ravago/shared/page-data/models/elements';
import { Alert } from '@ravago/shared/radiance/components/alert/components/Alert/Alert';

import { BadgeList } from '../../shared/badge-list/badge-list';

export const CaseStudyFeaturesListElement: FC<ElementProps<CaseStudyFeaturesListNode>> = ({ node, globals }) => {
   const { contentEntity, isConsumer } = globals;

   const caseStudy = contentEntity as NormalizedCaseStudy;
   const badges = useMemo(
      () =>
         caseStudy?.features.map((feature) => {
            const name = feature.name ?? '';
            return { id: name, label: name, variant: node.variant ?? 'neutral' };
         }) ?? [],
      [caseStudy, node.variant]
   );

   if (!caseStudy) {
      if (isConsumer) return null;

      return <Alert variant="info">No case study selected.</Alert>;
   }

   if (!badges.length) return null;

   return (
      <BadgeList
         size={node.size}
         weight="regular"
         badges={badges}
      />
   );
};
